import Android1 from './images/Android_1_150_mx.png';
import Android2 from './images/Android_Dodaj_150_mx.png';
import Ios1 from './images/IOS_1_150_mx.png';
import Ios2 from './images/IOS_Dodaj_150_mx.png';
import Last from './images/ios_android_3.png';

import VolumeUp from './images/dailyTutorial/volume-up.svg';
import HandsUp from './images/dailyTutorial/hand-up.svg';
import VolumeUpBlank from './images/dailyTutorial/volume-up-blank.svg';
import TranslationBlank from './images/dailyTutorial/icon-translate-blank.svg';
import HintBlank from './images/dailyTutorial/idea-blank.svg';
import InfoBlank from './images/dailyTutorial/information-blank.svg';
import GreenCircle from './images/dailyTutorial/green-circle.svg';
import YellowCircle from './images/dailyTutorial/yelow-circle.png';
import Microphone from './images/dailyTutorial/icon-microphone.svg';
import ScreenOne from './images/dailyTutorial/samouczek_czat_1.png';
import ScreenTwo from './images/dailyTutorial/samouczek_czat_2.png';
import ScreenThree from './images/dailyTutorial/samouczek_czat_3.png';
import ScreenFour from './images/dailyTutorial/samouczek_czat_4.png';
import Tutorial from './images/dailyTutorial/samouczek-fiolet.svg';

import Micro from './images/wordTrainerTutorial/icon-microphone.png';
import Voice from './images/wordTrainerTutorial/volume-up.svg';
import Person from './images/wordTrainerTutorial/user.svg';

export default {
	passwordRestart: {
		title: 'Restablecer contraseña',
		password: 'Contraseña',
		repeatPassword: 'Repetir contraseña',
		restartPawssord: 'Restablecer contraseña',
	},

	paywall: {
		title: 'Elige un plan para seguir aprendiendo',
		buy: 'Comprar',
		savePayment: 'Pagos seguros procesados por',
		skip: 'Omitir',
		pickPlan: 'Elige un plan',
		endPlanFirstPart: 'Tu acceso expirará en',
		endPlanSecondPart: 'días.',
		endPlanAditionalPart: 'día.',
		paymentTitle: 'Resumen',
		product: 'Producto:',
		plan: 'Paquete SynthiAi',
		forLong: 'Acceso por',
		data: 'datos:',
		nameAndSurname: 'Nombre completo:',
		paymentForm: 'Método de pago:',
		toPay: 'Total a pagar hoy:',
		accept: 'Aceptar',
		rules: 'términos',
		payingAccept: 'Al pagar, aceptas los',
		paymentRules: '"Términos de pago de PayU"',
		buyAndPay: 'COMPRAR Y PAGAR',
	},

	paymentStatus: {
		veryfication: 'Tu pago sigue en proceso...',
		title: 'Pago completado',
		success: '¡con éxito!',
		failure: '¡fallido!',
		subtitle: 'Serás redirigido a la página de inicio de sesión en breve.',
		textInfo: `Tu pago fue procesado exitosamente. Ahora puedes crear tu contraseña accediendo a nuestra página de registro. En unos minutos recibirás un correo electrónico con un enlace para establecer tu contraseña.

Revisa tu bandeja de entrada y también la carpeta de spam. Para facilitar la búsqueda, escribe "synthiai" en el campo de búsqueda. Si tienes problemas, contáctanos a: contact@synthiaiapp.com`,
		login: 'Ir al inicio de sesión',
	},

	register: {
		steps: {
			register: 'Registro',
			package: 'Paquete',
			summarize: 'Resumen',
			step: 'Paso ',
		},
		stepOne: {
			password: 'Contraseña',
			errorGoogle: 'Inicia sesión con tu correo electrónico.',
			title: 'Registro',
			nameAndSurname: 'Nombre completo',
			placeholderNameAndSurname: 'ej. Juan Pérez',
			email: 'Correo electrónico',
			placeholderEmail: 'ej. ejemplo@synthiaiapp.com',
			password: 'Contraseña',
			start: 'CREAR CUENTA',
			subtitle:
				'La contraseña debe tener al menos 8 caracteres, incluyendo mayúsculas, minúsculas y números.',
			passwordError1: 'La contraseña debe tener al menos 8 caracteres.',
			passwordError2: 'Debe incluir al menos una letra mayúscula.',
			passwordError3: 'Debe incluir al menos una letra minúscula.',
			passwordError4: 'Debe incluir al menos un número.',
			passwordError5: 'Las contraseñas deben coincidir.',
		},
		stepTwo: {
			title: 'Elige tu plan',
			month: 'Mes',
			months: 'Meses',
			months2: 'Meses',
			value: '€/Mes',
			pick: 'elegir',
			nowPay: 'Pagar ahora',
			saveOne: 'Ahorra',
			buy: 'Comprar',
			savePayment: 'Pagos seguros procesados por',
		},
		stepThree: {
			title: 'Resumen',
			product: 'Producto:',
			plan: 'Paquete Synthi Ai',
			forLong: 'Acceso por',
			data: 'Datos:',
			nameAndSurname: 'Nombre completo:',
			paymentForm: 'Método de pago:',
			toPay: 'Total a pagar hoy:',
			accept: 'Aceptar',
			rules: 'Reglamento',
			payingAccept: 'Al pagar, aceptas los',
			paymentRules: '"Términos de pago de PayU"',
			buyAndPay: 'COMPRAR Y PAGAR',
		},
	},

	firstLogin: {
		createPasswordForAcoount: 'Crea una contraseña para tu cuenta',
		typeEmail: 'Escribe tu correo electrónico',
		useSameEmail: 'Usa el mismo correo utilizado al comprar',
		typePassword: 'Escribe la contraseña',
		confirmPassword: 'Confirma la contraseña',
		createPassword: 'Crear contraseña',
		errorLogin: 'Verifica si el correo o contraseña son correctos',
		createdPassword: '¿Ya creaste tu contraseña?',
		clickToLogin: 'Haz clic aquí para iniciar sesión',
	},

	login: {
		dontHavePassword: '¿Aún no tienes una contraseña?',
		getPassword: 'Haz clic aquí para obtener acceso',
		title: 'Iniciar sesión',
		email: 'Correo electrónico',
		password: 'Contraseña',
		textSub: '¿Olvidaste tu contraseña? Restablécela',
		restart: 'aquí',
		restartPasswordText:
			'Ingresa tu correo para restablecer la contraseña. Te la enviaremos por correo electrónico.',
		placeholder: 'Escribe tu correo...',
		resetPassword: 'Restablecer contraseña',
		buttonText: 'Iniciar sesión',
		errorLogin: 'Verifica si el correo o contraseña son correctos',
		passwordResterted: 'Contraseña restablecida, revisa tu correo.',
		passwordError: 'No encontramos ese correo electrónico.',
		mobileAppBannerText: '¡Descubre nuestra app!',
	},

	navBar: {
		home: 'Inicio',
		learn: 'Aprender',
		profile: 'Perfil',
	},

	home: {
		hello: 'Hola',
		question: '¿Sobre qué te gustaría hablar hoy?',
		answer: 'Inicia una conversación',
		forYou: 'Recomendado para ti',
		popularNow: 'Popular ahora',
		doYouKnow: '¿Sabías que...?',
		funFact: 'Dato del día',
		new: 'Nuevo',
		check: 'Verificar',
		yourFavorite: 'Tus favoritos',
		newTitle: 'Entrenador de palabras',
		newSubtitle: 'Practica la pronunciación',
		talkWith: 'Habla de cualquier tema con',
		photoConversation: {
			photoConversationMode: 'Modo Conversación con Foto',
			goToChatTakeAPhoto:
				'Ve al chat, toma una foto o elige una de tu galería y habla sobre ella.',
			check: 'Verificar',
			new: 'Nuevo',
		},
	},
	learn: {
		wordTrainer: {
			title: 'Entrenador de palabras',
			subtitle: 'Practica la pronunciación de las palabras',
			new: 'Nuevo',
		},
		flashcardV2: {
			new: 'Nuevo',
			sport: 'Deportes',
			continue: 'continuar',
			nice: '¡Genial!',
			congratulation: '¡Felicidades!',
			category: 'Categoría',
			textAfterCategory: '¡ya no tiene secretos para ti!',
			pickNewCategory: 'Elige una nueva categoría',
			showResult: 'Mostrar solución',
			createWordWithLetters: 'Forma una palabra con las letras mezcladas',
			know: 'Lo sé',
			dontKnow: 'No lo sé',
			metchWords: 'Forma pares',
			addNewCategory: 'Agregar nueva categoría',
			personalizeLearning:
				'Personaliza tu aprendizaje creando tu propia categoría.',
			typeNewCategory: 'Escribe el nombre de tu categoría',
			save: 'Guardar',
			weAreCreatingCategoryForYou:
				'Estamos creando una nueva categoría para ti:',
			start: 'INICIAR',
			howToUseFlashcard: '¿Cómo usar las tarjetas?',
			knowFlashcard:
				'Haz clic en "No lo sé" o "Lo sé" para evaluar tu conocimiento.',
			dontKnowFlashcard: 'Las tarjetas marcadas como "Lo sé" no se repetirán.',
			clickToHear: 'Haz clic para escuchar la palabra.',
			clickForDefinition: 'Haz clic para ver la definición',
			clickForTranslation: 'Haz clic para ver la traducción y ejemplos',
			close: 'Cerrar',
			clickCategoryToStart:
				'Haz clic en la categoría seleccionada para empezar a aprender.',
			lookAsProgressBar:
				'La barra de progreso debajo de la categoría muestra cuántas palabras has dominado.',
			clickToSetupFavaroiteFlashcard:
				'Haz clic para marcar la categoría como favorita.',
			clickToCreateOwnCategory:
				'Haz clic para crear tu propia categoría de tarjetas.',
			howLearningLookLike: '¿Cómo es el aprendizaje?',
			restText:
				' El aprendizaje consiste en repasar tarjetas y evaluar tu conocimiento. También resolverás tareas simples.',
		},
		chat: {
			title: 'Chat',
			subtitle: 'Habla de cualquier tema.',
		},
		fotoMode: {
			title: 'Puzzle con foto',
			subtitle: 'Describe la imagen con el mayor detalle posible.',
		},
		scene: {
			title: 'Escenas',
			subtitle: 'Interpreta un rol con un tutor AI.',
		},
		word: {
			title: 'Palabras',
			subtitle: 'Amplía tu vocabulario.',
		},
		flashcard: {
			title: 'Tarjetas',
			subtitle: 'Repasa y memoriza palabras.',
		},
		seeMore: 'Ver todo',
	},
	common: {
		description:
			'Synthi AI - Tu asistente inteligente para aprender inglés. Aprende a hablar inglés con fluidez con ayuda de la inteligencia artificial. Descubre un enfoque nuevo y eficaz para aprender idiomas. ¡Empieza hoy!',
		deletedFromFavorite: 'Eliminado de favoritos',
		addedToFavorite: 'Agregado a favoritos',
		flashcards: 'Tarjetas',
		flashcards_v2: 'Tarjetas',
		scenes: 'Escenas',
		scenes_v3: 'Escenas',
		words: 'Palabras',
		or: 'o',
		continueWithFB: 'Continuar con Facebook',
		privacyLink: 'privacidad',
		termsLink: 'términos',
	},

	profile: {
		days: ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'],
		top: {
			profile: 'Perfil',
			accessTo: 'Acceso a:',
			profileImage: 'Imagen de perfil',
			nameAndSurname: 'Nombre completo',
			password: 'Contraseña',
			change: 'Cambiar',
			changeProfileImage: 'Cambiar imagen de perfil',
			changeNameAndSurname: 'Cambiar nombre completo',
			changeNameAndSurnamePlaceHolder: 'Escribe tu nombre completo',
			save: 'Guardar',
			changePassword: 'Cambiar contraseña',
			passwordInfo:
				'La contraseña debe tener al menos 8 caracteres, incluyendo letras, mayúsculas y números.',
			repeatPassword: 'Repetir contraseña',
			passwordChanged: '¡Contraseña cambiada!',
			error: 'Ups, algo salió mal',
			nameChanged: 'Nombre actualizado',
			profileChanged: 'Perfil actualizado',
		},
		plan: {
			subInfo:
				'Para cancelar tu suscripción, escribe a contact@synthiaiapp.com',
			yourPlan: 'Tu plan',
			extend: 'Renovar plan',
			short_extend: 'Renovar',
			currentPlan: 'Plan actual:',
			activeToPlan: 'Activo hasta:',
			currentPlanLong: 'Tu plan actual',
		},
		middle: {
			yourMedals: 'Tus medallas',
			oneDay: 'Día',
			twoDays: 'Días',
			words: 'Palabras',
			learningTime: 'Tiempo de aprendizaje',
			streak: 'Racha',
			streakRecord: 'Récord de racha',
			yourRecord: 'Tu récord:',
			currentRecord: 'Estado actual:',
			wordsInWeek: 'Palabras por semana:',
		},
		bottom: {
			yourTutor: 'Tu tutor AI',
			change: 'Cambiar',
			logout: 'Cerrar sesión',
			FAQ: 'Preguntas frecuentes',
			shareOpinion: 'Comparte tu opinión',
			yourPlan: 'Tu plan',
			hobby: 'Intereses',
			learningSetting: 'Configuraciones de aprendizaje',
			back: 'Atrás',
			dayTarget: 'Meta diaria',
			languageLevel: 'Nivel de idioma',
			changeYourLangLevel: 'Cambia tu nivel de idioma.',
			pickNewTutor: 'Elige un nuevo tutor',
			yourDecision: 'Tu elección afectará el estilo y ambiente de las clases.',
			tutroChanged: 'Tutor cambiado',
			error: 'Ups, algo salió mal',
			englishLevelChanged: 'Nivel actualizado',
			levelsOptions: [
				{
					name: 'Principiante A1',
					description: 'Empieza tu camino con el inglés',
					value: 'basic',
					borderRadius: '8px 8px 0 0',
				},
				{
					name: 'Principiante A2',
					description:
						'Puedes entender frases básicas en conversaciones simples.',
					borderRadius: '0',
					value: 'beginner',
				},
				{
					name: 'Intermedio B1',
					description:
						'Puedes mantener conversaciones simples y comprensibles sobre temas familiares.',
					borderRadius: '0',
					value: 'intermediate',
				},
				{
					name: 'Avanzado B2',
					description: 'Te comunicas libremente en la mayoría de situaciones',
					borderRadius: '0',
					value: 'advanced',
				},
				{
					name: 'Experto C1+',
					description:
						'Dominas el idioma de forma eficaz en contextos complejos.',
					value: 'expert',
					borderRadius: '0 0 8px 8px ',
				},
			],
			changeDailyTarget: 'Cambia tu meta diaria de estudio.',
			dailyTargetChanged: '¡Meta diaria actualizada!',
			pickIntresets: 'Elige al menos 3 intereses.',
			activeTo: 'Plan activo hasta:',
			daysLeft: 'Días restantes en el plan:',
			opinionSubtitle:
				'Estamos mejorando constantemente nuestra app. Cuéntanos qué podemos mejorar o qué te ha gustado más.',
			startTyping: 'Escribe tu opinión.',
			faq: 'Preguntas frecuentes',
			send: 'Enviar',
			withProblems: 'Si tienes dudas o problemas, contáctanos en:',
			contactMail: 'contact@synthiaiapp.com',
			faqConfig: [
				{
					id: 1,
					question: 'El sonido no funciona.',
					answer: `Si tienes problemas con el sonido, prueba lo siguiente:
					
					- Verifica los permisos de sonido en tu navegador.
					- Asegúrate de que el volumen de tu dispositivo esté activado.
					- Verifica la conexión de tus audífonos o bocinas.
					- Revisa que las apps no estén silenciadas en la configuración del sistema.
					- Prueba con otro dispositivo o contacta a soporte.`,
				},
				{
					id: 2,
					question: 'No puedo grabar mi voz.',
					answer: `Si tienes problemas con la grabación, intenta esto:
					
					- Verifica los permisos del micrófono en el navegador.
					- Asegúrate de que el navegador tenga acceso al micrófono.
					- Confirma que el micrófono esté bien conectado.
					- Usa otro dispositivo o contacta a soporte.`,
				},
				{
					id: 3,
					question: '¿Puedo usar la app en varios dispositivos?',
					answer:
						'Claro, solo inicia sesión en cada dispositivo compatible para seguir aprendiendo sin interrupciones.',
				},
				{
					id: 4,
					question: '¿Puedo usar Synthi Ai sin conexión?',
					answer:
						'No, Synthi Ai requiere acceso a internet mediante un navegador web.',
				},
				{
					id: 5,
					question: '¿Cómo cambio mi tutor AI?',
					answer:
						'Ve a "Tutor" en las configuraciones de Synthi Ai y elige el tutor que prefieras.',
				},
				{
					id: 6,
					question: '¿Cómo renuevo mi acceso tras el vencimiento?',
					answer:
						'Puedes renovar tu plan iniciando sesión después de la expiración.',
				},
				{
					id: 7,
					question: '¿Puedo recibir una factura?',
					answer:
						'Contáctanos en contact@synthiaiapp.com con tu RFC y datos fiscales.',
				},
				{
					id: 8,
					question: '¿Cómo contacto con soporte técnico?',
					answer:
						'Escríbenos a contact@synthiaiapp.com incluyendo detalles del problema, así como tu dispositivo y navegador.',
				},
			],
		},
		rules: 'Términos',
		privacy: 'Política de privacidad',
		span: ' y ',
	},
	welcome: {
		languagePicker: {
			title: 'Elige el idioma que quieres aprender',
			next: 'Siguiente',
			langToLearn: 'Idioma a aprender',
			successTitle: 'Idioma de aprendizaje actualizado',
			config: [
				{
					label: 'Inglés',
					label2: 'Inglés',
					labelInside: 'inglés',
					value: 'en',
				},
				{
					label: 'Alemán',
					label2: 'Alemán',
					labelInside: 'alemán',
					value: 'de',
				},
				{
					label: 'Español',
					label2: 'Español',
					labelInside: 'español',
					value: 'es',
				},
				{
					label: 'Francés',
					label2: 'Francés',
					labelInside: 'francés',
					value: 'fr',
				},
				{
					label: 'Italiano',
					label2: 'Italiano',
					labelInside: 'italiano',
					value: 'it',
				},
			],
		},
		zeroScreen: {
			welcomeInApp: '¡Bienvenido a la app Synthi AI!',
			start: '¡EMPECEMOS!',
			welcomeMobile: 'Bienvenido',
			config: {
				chrome: {
					title: 'Instala la app en tu dispositivo Android.',
					text1: 'Presiona el botón',
					text1bold: ' Opciones',
					image1: Android1,
					text2: 'Luego selecciona',
					text2bold: ' Añadir a la pantalla de inicio',
					image2: Android2,
					text3: '¡Listo! Synthi AI estará en tu pantalla principal.',
					image3: Last,
				},
				safari: {
					title: 'Instala la app en tu dispositivo iOS.',
					text1: 'Presiona el botón',
					text1bold: ' Compartir',
					image1: Ios1,
					text2: 'Luego selecciona',
					text2bold: ' Añadir a pantalla de inicio',
					image2: Ios2,
					text3: '¡Listo! Synthi AI estará en tu pantalla principal.',
					image3: Last,
				},
			},
		},
		firstScreen: {
			title: '¡Elige tu tutor!',
			subtitle: 'Tu decisión influirá en el estilo y ambiente de las clases.',
			next: 'CONTINUAR',
		},
		secondScreen: {
			title: '¿Cuál es tu nivel actual de {language}?',
			config: [
				{
					name: 'Principiante A1',
					description: 'Empieza tu camino con {language}.',
					value: 'basic',
				},
				{
					name: 'Principiante A2',
					description:
						'Puedes entender información básica en conversaciones cotidianas.',
					value: 'beginner',
				},
				{
					name: 'Intermedio B1',
					description:
						'Puedes mantener conversaciones simples y comprensibles sobre temas conocidos.',
					value: 'intermediate',
				},
				{
					name: 'Avanzado B2',
					description:
						'Te comunicas con fluidez en la mayoría de las situaciones.',
					value: 'advanced',
				},
				{
					name: 'Experto C1+',
					description: 'Dominio completo del idioma en contextos complejos.',
					value: 'expert',
				},
			],
			next: 'CONTINUAR',
		},
		thirdScreen: {
			title: '¿Cuáles son tus intereses?',
			subtitle: 'Elige al menos 3 intereses.',
			next: 'CONTINUAR',
		},
		fourthScreen: {
			title: '¿Cuántos minutos al día quieres estudiar?',
			subtitle: 'Elige tu objetivo diario de estudio.',
			next: '¡EMPEZAR!',
			config: [
				{
					name: 'Clase rápida',
					dsecription: 'Ideal para un estudio express',
					time: '5 minutos',
					value: 'five_minutes',
				},
				{
					name: 'Sesión estándar',
					dsecription: 'Perfecta para un ritmo equilibrado',
					time: '10 minutos',
					value: 'ten_minutes',
				},
				{
					name: 'Entrenamiento intenso',
					dsecription: 'Opción ideal para los más dedicados',
					time: '15 minutos',
					value: 'fifteen_minutes',
				},
			],
		},
	},
	features: {
		wordTrainer: {
			next: 'Siguiente',
			yourSpeaking: 'Tu pronunciación',
			you: 'Tú',
			title: 'Entrenador de palabras',
			errorMessage:
				'¡Ups! Ocurrió un problema al procesar tu grabación. Inténtalo de nuevo :)))',
			endScreenTitle: '¡Increíble! 🌟🌟🌟',
			endScreenTopInfo: 'Has dominado todas las',
			endScreenMiddleInfo: 'palabras',
			endScreenBottomInfo: 'de este nivel.',
			endScreenText:
				'Puedes empezar de nuevo o cambiar el nivel en configuraciones.',
			endScreenBottomText: 'Empezar de nuevo',
			endScreenEndText: 'Finalizar',
			sesionScoreTitle: '¡Lo estás haciendo genial! 🎉',
			sesionScoreSubTitle: 'Estás mejorando tu pronunciación',
			sesionScoreWord: 'Palabras',
			now: 'Ahora',
			sum: 'Total',
			continue: 'CONTINUAR',
			areYouSureToEndLesson: '¿Seguro que quieres terminar la lección?',
			speakingScore: 'Puntaje de pronunciación',
			GOOD_ARRAY: [
				'¡Bravo!',
				'¡Perfecto!',
				'¡Eres un campeón!',
				'¡Excelente!',
				'¡Increíble!',
				'¡Genial!',
			],
			BAD_ARRAY: [
				'¡No te rindas!',
				'¡Tú puedes!',
				'¡Estás cerca!',
				'¡Sigue practicando!',
				'¡Ya casi lo logras!',
				'No pasa nada, ¡intenta otra vez!',
			],
			OK_ARRAY: [
				'¡Vas por buen camino!',
				'¡Casi lo tienes!',
				'¡Mejorando cada vez más!',
				'¡Estás avanzando!',
				'¡Buen esfuerzo!',
			],
			hold: 'Mantén presionado',
			holdText: 'el micrófono y di:',
			tutorial: {
				title: '¿Cómo usar el Entrenador de Palabras?',
				options: [
					{
						label: 'Toca para escuchar la pronunciación correcta',
						icon: Micro,
					},
					{
						label: 'Mantén presionado y pronuncia la palabra',
						icon: Voice,
					},
					{
						label: 'Toca para escuchar tu grabación y perfeccionarla',
						icon: Person,
					},
				],
				close: 'CERRAR',
			},
		},

		sceneV3: {
			twoToFiveMinutes: '2–5 minutos',
			twoToFiveMin: '2–5 min',
			role: 'Rol',
			description: 'Descripción',
			task: 'Tarea',
			tasks: 'Tareas',
			conversationStarted: 'Conversación iniciada',
			areYouSureYouWantToLeave: '¿Seguro que quieres salir?',
			youWillLoseProgress: 'perderás el progreso',
			continue: 'Continuar',
			leave: 'Salir',
			congratulations: '¡Felicidades!',
			yourAnswersWereClearAndLucid:
				'Tus respuestas fueron claras y coherentes, y las frases estuvieron bien estructuradas.',
			finish: 'Finalizar',
			howToUseScenes: '¿Cómo usar Escenas?',
			buyingShoes: 'Comprando zapatos',
			clickSelectedScene: 'Haz clic en la escena para comenzar a aprender.',
			clickToMarkAsFavorite: 'Haz clic para marcar como favorita.',
			youSeeWhenSceneIsDone: 'Verás cuando la escena esté terminada.',
			howLearningLookLike: '¿Cómo es el aprendizaje?',
			learningIsAbout:
				'El aprendizaje consiste en tener una conversación breve y realista, siguiendo la descripción y tareas.',
			close: 'Cerrar',
			clickToShareOpinion: 'Haz clic para compartir tu opinión',
			clickToShownInstructions: 'Haz clic para ver instrucciones',
			clickToCheckTasks: 'Haz clic para ver las tareas',
			clickToHearAgain: 'Haz clic para escuchar de nuevo',
			clickToShowTranslation: 'Haz clic para ver la traducción',
			clickToShowHint: 'Haz clic para ver una pista',
			clickToReportAProblem: 'Haz clic para reportar un problema',
			yourAnswerIsCorrect: 'Tu respuesta es correcta',
			clickToShowCorrectAnswer:
				'Haz clic para ver la respuesta correcta y su explicación',
			clickInTheTextInput:
				'Haz clic en el campo de texto para escribir tu respuesta',
			clickToStartRecording: 'Haz clic para empezar a grabar',
			taskCompleted: 'Tarea completada',
			whenAllTasksAreDone:
				'Cuando todas las tareas estén hechas, la escena estará completada.',
			start: 'Comenzar',
			next: 'Siguiente',
			skip: 'Saltar',
			howToTalkInScenes: '¿Cómo hablar en Escenas?',
		},

		topbar: {
			back: 'Atrás',
		},

		fotoMode: {
			welcome: {
				title: 'Puzzle con foto',
				subtitle:
					'Describe lo que ves en la imagen con el mayor detalle posible sobre un tema elegido.',
				start: '¡Comenzar!',
			},
			info: {
				startTyping: 'Escribe...',
				newTask: 'Nueva tarea',
				send: 'Enviar',
			},
		},

		flashcards: {
			title: 'Tarjetas',
			subtitleTop:
				'Aprende y memoriza palabras nuevas con tarjetas interactivas.',
			addCategory: 'Agrega tu categoría',
			subtitle: 'Escribe el nombre de tu categoría',
			type: 'escribe la categoría...',
			add: 'Agregar',
			previous: 'Tarjeta anterior',
			task: 'Tarea',
			changeLevel: 'Cambiar nivel',
			dontKnow: 'No lo sé',
			know: 'Lo sé',
			pickPairs: 'Formar pares',
			goodJob: '¡Buen trabajo!',
			titleEnd: 'Tu dedicación es impresionante',
			subtitleEnd: '¿Listo para nuevos desafíos?',
			repeat: 'Repetir categoría',
			other: 'Elegir otra categoría',
			level: {
				title: 'Cambiar el nivel de las tarjetas',
				beginner: 'Principiante A1-A2',
				intermediate: 'Intermedio B1-B2',
				advance: 'Avanzado C1-C2',
				change: 'Cambiar',
			},
		},

		scene: {
			title: 'Escenas',
			subtitle:
				'Interpreta un rol y actúa una escena con tu tutor AI sobre un tema elegido.',
			suggest: 'Sugerir una nueva escena',
			talk: 'Hablar',
			deletedFromFavorite: 'Eliminado de favoritos',
			addedToFavorite: 'Agregado a favoritos',
		},

		word: {
			title: 'Palabras',
			subtitle:
				'Amplía tu vocabulario en temas clave de conversación con tu tutor AI.',
			suggest: 'Sugerir un nuevo tema de palabras',
			deletedFromFavorite: 'Eliminado de favoritos',
			addedToFavorite: 'Agregado a favoritos',
		},
	},
	cookie: {
		title: 'Este sitio utiliza cookies',
		subtitle:
			'Usamos cookies para personalizar el contenido, analizar el tráfico y mostrar anuncios personalizados. Puedes gestionar tus preferencias de privacidad. Más detalles en la',
		link: 'Política de privacidad',
		accept: 'ACEPTAR',
		denied: 'RECHAZAR',
		manage: 'Personalizar',
		saveChanges: 'Guardar selección',
		necessary: {
			top: 'Necesarias',
			text: 'Estas cookies son esenciales para el funcionamiento del sitio.',
		},
		functional: {
			top: 'Funcionales',
			text: 'Recuerdan tus preferencias, como el idioma.',
		},
		analytical: {
			top: 'Analíticas',
			text: 'Nos ayudan a medir el tráfico y mejorar el sitio.',
		},
		marketing: {
			top: 'De marketing',
			text: 'Permiten mostrar anuncios personalizados y realizar remarketing.',
		},
		personalization: {
			top: 'Personalización del contenido',
			text: 'Permiten personalizar el contenido y recomendaciones según tus intereses.',
		},
	},
	talkingBar: {
		allowMicrofon: 'Por favor, permite el acceso al micrófono',
		typeMessage: 'Escribe un mensaje...',
		record: 'Grabar',
		recording: 'Grabando',
	},
	hands: {
		giveUsInfo: 'Comparte tu opinión con nosotros.',
		thanksForGrading: '¡Gracias por tu evaluación!',
		subtitle: '¡Tu opinión es importante para nosotros!',
		subtitle2: 'Dinos qué opinas de esta lección:',
		skip: 'OMITIR',
		send: 'ENVIAR',
	},

	suggestConfig: {
		profile: {
			title: '¡Comparte tu opinión!',
			subtitle:
				'Siempre estamos mejorando la app. Dinos qué podemos mejorar o qué te ha gustado más.',
		},
		word: {
			title: 'Sugiere un nuevo tema de palabras',
			subtitle: '',
		},
		scene: {
			title: 'Sugiere una nueva escena',
			subtitle: '',
		},
		startTyping: 'Empieza a escribir',
		send: 'ENVIAR',
		thx: '¡Tu opinión ha sido enviada! ¡Gracias!',
		error: 'Ups, algo salió mal',
	},

	checkout: {
		emailGuessText: '¿Quisiste decir',
		leftTitle: 'Elige un plan para ti',
		rightTitle: 'Completa tus datos',
		email: 'Correo electrónico',
		placeHolderEmail: 'Escribe tu correo',
		pay: 'COMPRAR Y PAGAR',
		accept: 'Aceptar',
		rules: 'reglamento',
		space: 'y',
		tos: 'política de privacidad',
		payingAccept: 'Al pagar, aceptas',
		paymentRules: '"Reglas de pago de PayU"',
		savePayments: 'Pagos seguros garantizados por',
		total: 'Total',
		currency: 'mxn',
		currencySign: '$',
		subscribe: 'PAGAR AHORA',
		payNow: 'COMPRAR AHORA',
		planConfig: {
			price: 'Precio',
			pre: 'Únete a',
			preColor: ' 50,000',
			post: 'personas que ya están cumpliendo sus metas',
			postColor: 'con Synthi AI',
		},
	},

	dailyV2: {
		conversation: {
			doYouWantContinueConversation:
				'¿Quieres continuar la conversación o empezar una nueva?',
			continueConversation: 'Continuar conversación',
			newConversation: 'Nueva conversación',
		},
		hint: {
			title: 'Pista',
			pick: 'Elegir',
			writeOrRecordAResponse: 'Escribe o graba una respuesta',
			tryToSay: 'Intenta decir',
		},
		feedback: {
			yourMessage: 'Tu mensaje',
			goodMessage: 'Mensaje correcto',
			explanation: 'Explicación',
		},
		tutorial: {
			title: '¿Cómo usar el chat?',
			skip: 'Saltar',
			next: 'SIGUIENTE',
			start: 'Empezar',
			screenConf: [ScreenOne, ScreenTwo, ScreenThree, ScreenFour],
			config: [
				[
					{
						title: 'Toca para silenciar al tutor',
						image: VolumeUp,
					},
					{ title: 'Toca para dejar tu opinión', image: HandsUp },
					{
						title: 'Haz clic para abrir instrucciones',
						image: Tutorial,
					},
				],
				[
					{ title: 'Toca para reproducir de nuevo', image: VolumeUpBlank },
					{
						title: 'Toca para ver la traducción',
						image: TranslationBlank,
					},
					{ title: 'Toca para ver una pista', image: HintBlank },
					{ title: 'Toca para reportar un problema', image: InfoBlank },
				],
				[
					{ title: 'Tu respuesta es correcta', image: GreenCircle },
					{
						title: 'Toca para ver la corrección y explicación',
						image: YellowCircle,
					},
				],
				[
					{ title: 'Toca el campo de texto para escribir un mensaje' },
					{ title: 'Toca para grabar un mensaje', image: Microphone },
				],
			],
		},
	},

	problem: {
		title: 'Reportar un problema',
		subtitle: 'Describe el problema relacionado con el mensaje de la IA',
		send: 'Enviar',
		messageSend: 'Mensaje enviado',
		error: 'Algo salió mal, escríbenos :)',
	},

	footer: {
		copy: 'Copyright©',
		privacy: 'Política de privacidad',
		cookie: 'Política de cookies',
		rules: 'Términos y condiciones',
		privacyUrl: '/privacy',
		rulesUrl: '/tos',
	},
};
